import { Box, Typography } from "@mui/material"
import Paper from "@mui/material/Paper"
import { styled } from "@mui/material/styles"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { TextBodyMain, TextTitleMain } from "../text/TextMain"
import { TableMainContextProvider, useTableMainContext } from "./TableMainContext"

export function TableMain({ items, data, options }) {
	return (
		<TableMainContextProvider data={data} items={items} options={options}>
			<TableContainer component={Paper}>
				<Box>
					<TableToolbar />
				</Box>
				<Table sx={{ minWidth: 420 }} aria-label="simple table">
					<TableMainHead />
					<TableMainBody {...{ items, data }} />
				</Table>
			</TableContainer>
		</TableMainContextProvider>
	)
}

const TableToolbar = () => {
	const { options } = useTableMainContext()
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "right",
				// mb: 1,
				alignContent: "center",
				// backgroundColor: COLOR_PRIMARY,
			}}
		>
			{options?.customToolbar && options.customToolbar()}
		</Box>
	)
}

const TableMainHead = () => {
	const { items } = useTableMainContext()
	const itemsComponent = items.map((item) => {
		const IdCell = item.name || item.label
		return (
			<StyledTableCell key={IdCell}>
				<TextTitleMain label={item.label || item.name} />
			</StyledTableCell>
		)
	})
	return (
		<TableHead>
			<TableRow>{itemsComponent}</TableRow>
		</TableHead>
	)
}

const TableMainBody = () => {
	const { items, data } = useTableMainContext()
	const itemsCell = (datum) =>
		items.map((item) => {
			const idCell = item.name || item.label
			let component = <TextBodyMain>{datum[item.name]}</TextBodyMain>

			if (item?.options?.customBodyRender)
				component = item.options.customBodyRender(datum[item.name], datum)

			if (typeof component === "string")
				component = <TextBodyMain>{component}</TextBodyMain>

			return <TableCell key={`${idCell}-item${datum["id"]}`}>{component}</TableCell>
		})

	let itemsComponents = data.map((datum, index) => {
		return <TableRowStyle datum={datum}>{itemsCell(datum)}</TableRowStyle>
	})

	return (
		<TableBody>
			{itemsComponents}
			<CompetenceTableNoItems />
		</TableBody>
	)
}

const CompetenceTableNoItems = () => {
	const { data, items, options } = useTableMainContext()
	if (data.length !== 0) return null
	return (
		<TableRowStyle>
			<TableCell component="th" scope="row" colSpan={items.length + 1} align="center">
				<Typography variant="h5" fontWeight="bold">
					{options?.noDataText || "No hay datos"}
				</Typography>
			</TableCell>
		</TableRowStyle>
	)
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		// backgroundColor: COLOR_PRIMARY,
		color: theme.palette.common.black,
		fontSize: 14,
	},
}))

const TableRowStyle = ({ datum, children, ...props }) => {
	const { options } = useTableMainContext()

	const RowProps = {}
	const sxProps = {}
	if (options?.selectedRow)
		sxProps.sx = {
			cursor: "pointer",
			"&:hover": {
				backgroundColor: "action.hover", // color de fondo en hover
			},
		}
	if (datum && options?.onClickRow)
		RowProps.onClick = () => {
			options.onClickRow(datum)
		}
	return (
		<TableRow
			sx={{ "&:last-child td, &:last-child th": { border: 0 }, ...sxProps.sx }}
			{...RowProps}
			{...props}
		>
			{children}
		</TableRow>
	)
}
